import auth from "@/middlewares/auth";
import guest from "@/middlewares/guest";

import { bannerRoutes } from "@/routes/banner/bannerSetting";
import { pages } from "@/routes/pages";
import { blogs } from "@/routes/blogs";
import { news } from "@/routes/news";
import { gallery } from "@/routes/gallery";
import { notice } from "@/routes/notice";
import { lecture } from "@/routes/lecture";
import { scrollNotice } from "@/routes/scrollNotice";
import { board } from "@/routes/board";
import { settings } from "@/routes/settings";
import { users } from "@/routes/users";
import { customers } from "@/routes/customers";

let routes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login'),
    name: 'login',
    meta: {
      middleware: [
        guest
      ]
    }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard'),
    name: 'dashboard',
    meta: {
      middleware: [
        auth
      ]
    }
  }
]

routes.push(...bannerRoutes);
routes.push(...pages);
routes.push(...blogs);
routes.push(...news);
routes.push(...gallery);
routes.push(...notice);
routes.push(...lecture);
routes.push(...scrollNotice);
routes.push(...board);
routes.push(...settings);
routes.push(...users);
routes.push(...customers);

export default routes;
